import { BaseDto } from '../../core';
import { APPROVED_STATUS, CAMPAIGN_TYPE, CAMPAIGN_USABLE_TYPE, OBTAIN_RULE_TYPE } from '../../shared';
import { CampaignSettingUsableType } from './campaign-setting-usable-type.entity';
import { CampaignSettingObtainRule } from './campaign-setting-obtain-rule.entity';
import { CampaignSettingMapperSampleProduct } from './campaign_setting_mapper_sample_product.entity';
import { Cart } from '..';
import { Utils } from '../../common';
import { Buyer, BuyerCompany } from '../buyer';
import { BuyerService } from '../../services';

export class CampaignNames {
  en: string;
  vi: string;
}

export class CampaignSetting extends BaseDto<CampaignSetting> {
  constructor(partial?: Partial<CampaignSetting>) {
    super(partial);
    if (partial.campaignSettingMapperSampleProducts && partial.campaignSettingMapperSampleProducts.length) {
      this.campaignSettingMapperSampleProducts = partial.campaignSettingMapperSampleProducts.map(
        (campaignSettingMapperSampleProduct) =>
          new CampaignSettingMapperSampleProduct(campaignSettingMapperSampleProduct).setAll({
            userSelectedProductCount: 0,
            obtainRuleValueRangeByStock: 0,
          })
      );
    }

    this.selectMapperSaleProductId = 'N';
    this.isAvailableCampaign = true;
    this.sumItemPrice = 0;
    this.requiredUSD = 0;
  }

  id: number;
  name: string;
  localeName: CampaignNames;

  // 캠페인타입 - SAMPLE_PRODUCT : SAMPLE 지급
  campaignType: CAMPAIGN_TYPE;
  // 캠페인 획득 룰 타입 - PURCHASE_PRICE : 구매 가격기준
  obtainRuleType: OBTAIN_RULE_TYPE;
  started: Date;
  ended: Date;

  // 사용 범위 : ALL, BRAND, COUNTRY
  campaignUsableType: CAMPAIGN_USABLE_TYPE;
  approvedStatus: APPROVED_STATUS;
  approvedStatusUpdated: Date | null;
  created: Date;
  campaignSettingUsableTypes: CampaignSettingUsableType[];
  campaignSettingObtainRules: CampaignSettingObtainRule[];
  campaignSettingMapperSampleProducts?: CampaignSettingMapperSampleProduct[];

  selectMapperSaleProductId: string | number;

  // for tempalte
  isAvailableCampaign: boolean;
  sumItemPrice: number;
  requiredUSD: number;
  campaignUsableTypeList?: string;

  setIsAvailableCampaign(carts: Cart[]) {
    this.sumItemPrice = Utils.getUSDToFixed(
      carts.reduce((sum: number, cart: Cart) => {
        switch (this.campaignUsableType) {
          case CAMPAIGN_USABLE_TYPE.BRAND:
            return this.isIncludebrand(cart) ? sum + cart.totalSalePriceUSD : sum;
          case CAMPAIGN_USABLE_TYPE.PRODUCT:
            return this.isIncludeproduct(cart) ? sum + cart.totalSalePriceUSD : sum;
          case CAMPAIGN_USABLE_TYPE.COUNTRY:
          case CAMPAIGN_USABLE_TYPE.ALL:
            return sum + cart.totalSalePriceUSD;
        }
      }, 0)
    );
    this.isAvailableCampaign = this.sumItemPrice >= this.campaignSettingObtainRules[0].obtainRuleCondition;
    if (!this.isAvailableCampaign) {
      this.requiredUSD = Utils.getUSDToFixed(
        this.campaignSettingObtainRules[0].obtainRuleCondition - this.sumItemPrice
      );
    }
  }

  setCampaignUsableTypeList() {
    switch (this.campaignUsableType) {
      case CAMPAIGN_USABLE_TYPE.BRAND:
        this.campaignUsableTypeList = this.campaignSettingUsableTypes
          .map((campaignSettingUsableType) => campaignSettingUsableType.brand.englishName)
          .join(', ');
        break;
      case CAMPAIGN_USABLE_TYPE.COUNTRY:
        this.campaignUsableTypeList = this.campaignSettingUsableTypes
          .map((campaignSettingUsableType) => campaignSettingUsableType.country.data.name.common)
          .join(', ');
        break;
    }
  }

  isIncludebrand(cart: Cart) {
    const has = this.campaignSettingUsableTypes.filter(
      (campaignSettingUsableType) => campaignSettingUsableType.brand.id === cart.mapperSaleProduct.product.brandId
    );
    return has.length;
  }

  isIncludeproduct(cart: Cart) {
    const has = this.campaignSettingUsableTypes.filter(
      (campaignSettingUsableType) => campaignSettingUsableType.id === cart.mapperSaleProduct.product.id
    );
    return has.length;
  }
}
